import { MouseEventHandler } from "react"
import { A } from "src/components/generic/A"
import { Tooltip } from "src/components/generic/Tooltip"
import { Icon, IconName } from "../../generic/Icon"
import { NotificationPill } from "../../generic/NotificationPill"

export type HeaderIconLink = {
  href?: string
  onClick?: MouseEventHandler
  iconName: IconName
  title: string
  notification?: string
}

export const HeaderIconLink = ({ href, onClick, iconName, title, notification }: HeaderIconLink) => {
  const Component = href ? A : "button"
  const type = href ? undefined : "button"

  return (
    <Tooltip text={title}>
      <Component
        type={type}
        href={href}
        onClick={onClick}
        className="hover:text-np-green relative flex items-center gap-2 rounded-full p-2 transition-colors hover:bg-gray-100 hover:transition-none"
        aria-label={title}
      >
        <Icon name={iconName} className="size-9" />
        {notification && (
          <div className="absolute top-0 right-0 -translate-x-1/4 translate-y-1/4">
            <NotificationPill>{notification}</NotificationPill>
          </div>
        )}
      </Component>
    </Tooltip>
  )
}
